import { Link, useLocation } from "@tanstack/react-router";
import type { NavDropdownItem } from "../NavDropdown";

interface PublicDesktopNavProps {
	forWhoItems: NavDropdownItem[];
	featuresItems: NavDropdownItem[];
}

export function PublicDesktopNav({
	forWhoItems: _forWhoItems,
	featuresItems: _featuresItems,
}: PublicDesktopNavProps) {
	const location = useLocation();

	const isActive = (path: string) =>
		location.pathname === path ||
		location.pathname.startsWith(`${path}/`);

	const navLinkClass = (path: string) =>
		`relative px-3 py-2 text-sm font-bold rounded-[6px] transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 ${
			isActive(path)
				? "text-foreground bg-foreground/[0.06]"
				: "text-foreground/60 hover:text-foreground hover:bg-foreground/[0.04]"
		}`;

	return (
		<nav aria-label="Main navigation" className="hidden lg:flex items-center gap-1 ml-6">
			<Link
				to="/models"
				aria-current={isActive("/models") ? "page" : undefined}
				className={navLinkClass("/models")}
			>
				Models
			</Link>
			<Link
				to="/help"
				aria-current={isActive("/help") ? "page" : undefined}
				className={navLinkClass("/help")}
			>
				Docs
			</Link>
			<Link
				to="/pricing"
				aria-current={isActive("/pricing") ? "page" : undefined}
				className={navLinkClass("/pricing")}
			>
				Pricing
			</Link>
		</nav>
	);
}
